import { Typography, Tooltip, theme } from "antd";
import { Question as QuestionClass, SurveyError } from "survey-core";
import { SurveyQuestion, SurveyElementBase } from "survey-react-ui";

export class Question extends SurveyQuestion {
  protected renderHeader(question: QuestionClass) {
    const allowTitleWrap = question.getPropertyValue("allowTitleWrap");
    const truncateStyle: React.CSSProperties = {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    };

    return (
      <div
        style={{
          marginBottom: "8px",
          gap: "8px",
          display: "flex",
        }}
      >
        <label
          htmlFor={question.inputId}
          title={
            question.isRequired
              ? question.fullTitle
              : `${question.fullTitle} (Optioneel)`
          }
          style={{
            ...(allowTitleWrap ? {} : truncateStyle),
            display: "block",
            minWidth: 0,
            flex: 1,
          }}
        >
          <QuestionLabel>{question.fullTitle}</QuestionLabel>
          {!question.isRequired ? (
            <Typography.Text aria-hidden="true" style={{ color: "#777" }}>
              {" "}
              (Optioneel)
            </Typography.Text>
          ) : null}
        </label>

        {question.description ? (
          <Tooltip
            title={SurveyElementBase.renderLocString(question.locDescription)}
          >
            <span
              style={{
                borderRadius: 20,
                width: 24,
                height: 24,
                border: "1px solid #ccc",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "help",
              }}
            >
              ?
            </span>
          </Tooltip>
        ) : null}
      </div>
    );
  }

  protected renderErrors() {
    const q = this.question;
    if (!q || !q.errors || q.errors.length === 0) return <></>;

    return (
      <div role="alert" aria-live="polite" id={`${q.inputId}-errors`}>
        {q.errors.map((err: SurveyError, i: number) => (
          <Typography.Text style={{ color: "red" }} key={i}>
            {err.getText()}
          </Typography.Text>
        ))}
      </div>
    );
  }

  protected renderSubtitle() {
    const subtitle = this.question.getPropertyValue("subtitleValue");
    if (!subtitle) return null;

    return (
      <Typography.Text
        type="secondary"
        style={{ display: "block", marginTop: "4px", fontSize: "13px" }}
      >
        {subtitle}
      </Typography.Text>
    );
  }

  protected wrapQuestionContent(element: React.JSX.Element): React.JSX.Element {
    const subtitle = this.renderSubtitle();
    if (!subtitle) return element;

    return (
      <>
        {element}
        {subtitle}
      </>
    );
  }
}

export const QuestionLabel = ({ children }: { children: React.ReactNode }) => {
  const { useToken } = theme;
  const { token } = useToken();

  return (
    <Typography.Text
      style={{
        fontSize: token.labelFontSize,
        fontWeight: token.labelFontWeight,
      }}
    >
      {children}
    </Typography.Text>
  );
};
